/** Login / refresh calls must not trigger session refresh or forced logout redirects. */
export function isAuthEntryRequest(url) {
  if (!url) return false;
  const path = String(url);
  return (
    path.includes('/shared/auth/login')
    || path.includes('/shared/auth/refresh')
    || path.includes('/shared/auth/logout-session')
    || path.includes('/shared/auth/verify-email')
  );
}

/** Public routes where silent cookie refresh is unnecessary (user is not in an app session). */
export function isPublicSessionRestoreSkipPath() {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname.toLowerCase();
  return (
    path === '/login'
    || path.startsWith('/login/')
    || path === '/verify-email'
    // OAuth popup/callback is public; forcing refresh-token restore there can clear
    // SESSION_HINT_KEY on failure and log the user out after the popup returns.
    // But only skip when this callback is running as a popup (there is an opener),
    // otherwise we still need restoreSession to rebuild the in-memory token.
    || (path === '/meta-oauth-callback' || path.startsWith('/meta-oauth-callback')) && (
      (() => {
        try {
          return !!window.opener && !window.opener.closed;
        } catch {
          return false;
        }
      })()
    )
    || path === '/subscription-inactive'
  );
}
